export const lang = {
    home: "知識庫",
    account: {
        title: "帳號",
        vip: {
            title: "VIP",
            url: "../../static/img/tw/0_4.png"
        },
        forget: {
            title: "忘記帳號密碼",
            url: "../../static/img/tw/1_3.png"
        },
        active: {
            title: "活躍指數",
            url: "../../static/img/tw/2.png"
        }
    },
    props: {
        title: "道具",
        history: {
            title: "歷史紀錄",
            url: "../../static/img/tw/3_1.png"
        },
        bag: {
            title: "福袋",
            url: "../../static/img/tw/4_1.png"
        },
        backpack: {
            title: "背包",
            url: "../../static/img/tw/5.png"
        },
        card: {
            title: "虛寶卡",
            url: "../../static/img/tw/6_1.png"
        }
    },
    chat: {
        title: "聊天",
        big: {
            title: "大聲公",
            url: "../../static/img/tw/7.png"
        },
        push: {
            title: "群長推播",
            url: "../../static/img/tw/8.png"
        },
        red: {
            title: "群長紅包",
            url: "../../static/img/tw/9.png"
        },
        chat: {
            title: "聊天",
            url: "../../static/img/tw/10.png"
        }
    },
    game: {
        title: "遊戲",
        keep: {
            title: "保留座",
            url: "../../static/img/tw/11.png"
        },
        scratch: {
            title: "刮刮樂",
            url: "../../static/img/tw/12.png"
        },
        jackpot: {
            title: "連線彩金",
            url: "../../static/img/tw/13_1.png"
        },
        choice: {
            title: "選座大廳",
            url: "../../static/img/tw/14.png"
        }
    },
    bank: {
        title: "銀行",
        forgetPass: {
            title: "忘記贈禮密碼",
            url: "../../static/img/tw/15_2.png"
        },
        trade: {
            title: "贈禮",
            url: "../../static/img/tw/16_1.png"
        },
        tradeList: {
            title: "贈禮名單",
            url: "../../static/img/tw/17_1.png"
        },
        tradeLimit: {
            title: "贈禮限制",
            url: "../../static/img/tw/18_4.png"
        }
    },
    advice: {
        title: "建議設備",
        url: "../../static/img/tw/19.png"
    },
    rules: {
        title: "使用者規章",
        game: {
            title: "遊戲管理規章",
            total: "遊戲管理規則",
            detail: "親愛的王牌俱樂部(下稱「遊戲」)玩家您好，為了要提供廣大玩家更健全的服務，隆中網絡股份有限公司(以下簡稱「本公司」)依會員服務條款第十五條制定了遊戲管理規則(以下簡稱「本規則」)，需要各位玩家一起遵守本規則內容，為各位玩家帶來更良好的遊戲環境。",
            one: {
                title: "壹、規則效力",
                first: "一、為保障您的權益，請詳細閱讀本規則所有內容，當您在線上勾選「我同意」並註冊完成；或開始使用遊戲服務時，即表示您已經詳細閱讀、了解，並同意遵守本規則。如果您對於本規則有任何的疑慮，或是不同意時，將無法繼續使用本遊戲服務。",
                second: "二、提醒您，要先行審閱本規則三日以上，再按「我同意」。",
                third: "三、如您為限制行為能力人或受輔助宣告之人，應經您的法定代理人、監護人或輔助人閱讀、了解並同意本規則之所有內容及其後修改變更後，方得使用或繼續使用本遊戲服務；若您為無行為能力人，則應由您的法定代理人或監護人代為意思表示。"
            },
            two: {
                title: "貳、個人資料保證",
                first: "一、個人註冊資料需確實登錄，如為不實資料，本公司可拒絕提供相關服務；經確認違規事項嚴重者，本公司得將該違規帳號或其相關聯帳號依照本規則規定處理。",
                second: "二、如玩家於註冊帳號時，使用不實之註冊資料或將其「遊戲帳號」、「密碼」等遊戲相關資料洩漏、交付或轉讓予他人時，本公司有權與此帳號終止契約，並由玩家自行承擔所有之損失，如讓本公司受有其他損害者，應賠償本公司之損害，本公司具有保留法律追訴之權利。"
            },
            three: {
                title: "參、違規罰則",
                detail: "若玩家於遊戲違反下述規則，本公司得視情節輕重以禁言、限制全部或部份您進行遊戲之權利(下稱「停權」)、回收相關電磁紀錄或終止契約，由玩家自行承擔遊戲帳號之所有損失、損害與責任，以及一切遊戲中所使用點數等損失，本公司將不負任何賠償法律責任。因玩家違反本規則造成本公司之一切損失，本公司有權向玩家進行求償。",
                num: "編號",
                illegal: "違規項目",
                instruction: "罰則說明",
                table: {
                    1: {
                        title: {
                            one: "遊戲中使用不當名稱與帳號"
                        },
                        detail: {
                            one: "初犯：警告通知並更名及扣減活躍指數",
                            two: "累犯：停權七日",
                            three: "三次：終止契約"
                        }
                    },
                    2: {
                        title: {
                            one: "遊戲中使用不當頭像"
                        },
                        detail: {
                            one: "初犯：警告通知並強制更換頭像及扣減活躍指數",
                            two: "累犯：停權七日",
                            three: "三次：終止契約"
                        }
                    },
                    3: {
                        title: {
                            one: "遊戲中進行不當發言或任何文字"
                        },
                        detail: {
                            one: "初犯：警告通知並禁言及扣減活躍指數",
                            two: "累犯：停權七日或解散群組",
                            three: "三次：終止契約"
                        }
                    },
                    4: {
                        title: {
                            one: "不當遊戲行為"
                        },
                        detail: {
                            one: "初犯：警告通知及扣減活躍指數",
                            two: "累犯：停權七日",
                            three: "三次：終止契約"
                        }
                    },
                    5: {
                        title: {
                            one: "疑似盜(冒)用他人帳號、資料行為或為因他人盜用帳號密碼取得電磁紀錄之玩家"
                        },
                        detail: {
                            one: "依會員服務條款第九條規定處理"
                        }
                    },
                    6: {
                        title: {
                            one: "對遊戲系統進行攻擊或破壞之行為",
                            two: "利用【王牌俱樂部】販售、購買遊戲點數、遊戲幣、虛擬物品之行為",
                            three: "遊戲中使用非法程式或利用錯誤進行遊戲",
                            four: "使用冒名、詐欺或其他虛偽不正之方式進行儲值或購買遊戲內之商品"
                        },
                        detail: {
                            one: "通知後立即終止契約及求償，並報請司法機關處理"
                        }
                    },
                    7: {
                        title: {
                            one: "經司法機關查獲從事非法行為"
                        },
                        detail: {
                            one: "終止契約"
                        }
                    },
                    8: {
                        title: {
                            one: "主管機關來函要求鎖定或調查"
                        },
                        detail: {
                            one: "停權配合至案件結案"
                        }
                    },
                    9: {
                        title: {
                            one: "惡意申訴回報、辱罵或影響客服人員及客服中心作業"
                        },
                        detail: {
                            one: "初犯：警告通知並暫時拒絕提供諮詢服務及扣減活躍指數",
                            two: "累犯：停權七日",
                            three: "三次：終止契約"
                        }
                    }
                }
            },
            four: {
                title: "肆、違規罰則說明",
                first: "1. 玩家不得使用任何非法、不雅、種族主義、淫穢、誹謗、污蔑、威脅、不實、猥褻、詐騙的內容(含相關影射)，或侵害他人智慧財產權的資訊、散播錯誤資訊或從事廣告、仲介或販賣商品、任何違反法律、被普遍認為屬不當資訊的內容(含相關影射)、提供不當的網址或連結、特殊字元等創立角色帳號、暱稱或群組名稱，違反規定者，本公司將於遊戲中進行警告通知與扣減活躍指數，且有權重新設定玩家帳號、暱稱或解散群組。經警告後仍再犯，將處以停權七日。如仍繼續違反，將終止與玩家間之遊戲契約。",
                second: "2. 玩家在使用玩家圖像、頭像，不得透過本服務張貼任何非法、不雅、種族主義、淫穢、誹謗、污蔑、威脅、不實、猥褻、詐騙的內容(含相關影射)，或侵害他人智慧財產權的資訊、散播錯誤資訊或從事廣告、仲介或販賣商品、任何違反法律、被普遍認為屬不當資訊的內容(含相關影射)及提供不當的網址或連結。違反規定者，本公司將於遊戲中進行警告通知與扣減活躍指數，且有權重新設定玩家圖像或頭像。經警告後仍再犯，將處以停權七日。如仍繼續違反，將終止與玩家間之遊戲契約。",
                third: "3. 玩家不得於遊戲中使用聊天功能或群組功能進行不當發言，包含但不限於公布或傳送任何非法(如任何買賣，販毒、情色交易等)、不雅、種族主義、淫穢、誹謗、污蔑、威脅、不實、猥褻、詐騙的內容(含相關影射)或連續性發言、侵害他人智慧財產權的資訊、散播遊戲資訊或從事廣告、仲介或販賣商品（虛寶道具、遊戲數值、幣值、點數等）、提供不當的網址或連結行為及遊戲言詞內容假冒官方人員，或自稱官方代表、遊戲管理者。違反規定者，本公司將於遊戲中進行警告通知，且有權禁止玩家發言並扣減活躍指數。經警告後仍再犯，將處以停權七日或解散群組。如仍繼續違反，將終止與玩家間之遊戲契約。",
                fourth: "4. 玩家禁止從事不當遊戲行為。包含但不限於干擾遊戲或活動之進行、點數儲值與轉帳比率異常、從事傷及第三人隱私或權益、大量申請新帳號破壞遊戲秩序、從事詐騙等情事；違反規定者，本公司將於遊戲中進行警告通知並扣減活躍指數，經警告後仍再犯，將處以停權七日。如仍繼續違反，將終止與玩家間之遊戲契約。",
                fifth: {
                    title: "5. 遊戲中禁止一切非法行為，違反規定者，本公司將直接通知終止契約，並報請司法機關辦理。包含：",
                    one: "1. 玩家利用任何系統或工具對本公司電腦系統進行影響、惡意攻擊或破壞。",
                    two: "2. 玩家使用外掛程式、病毒等非法程式、遊戲系統錯誤或漏洞(BUG)或其他違反遊戲常態設定或公平合理之方式進行遊戲，或是透過非法程式進行任何可能破壞遊戲內平衡性、影響其他玩家權益、造成活動比賽不公等影響遊戲系統之行為。",
                    three: "3. 玩家進行盜用、詐欺或盜刷等虛偽不正等行為取得點數或遊戲商品(虛寶道具、遊戲數值、幣值、點數等)。"
                },
                sixth: "6. 經司法機關查獲為任何不法行為者，本公司一律直接終止與玩家間之遊戲契約。",
                seventh: "7. 公務機關(主管機關、檢調單位、司法機關或其他政府機關之命令)來函要求鎖定或調查，本公司均配合辦理，玩家不得因此而要求任何補償或賠償。是否復權或何時復權依主管機關來函為標準。",
                eighth: "8. 活躍指數為玩家間互動評估之資訊，若玩家違反本規則，系統將自動扣分，請玩家特別注意。",
                ninth: "9. 玩家因參與競賽、贈獎活動而為違反本規則之行為者，經查證屬實後，本公司將同步取消其獲獎權利。",
                tenth: "10. 數帳號實質上為同一人所有時，其中一個帳號進行違反本規則之行為，本公司得就同一人其他帳號為相同處罰。將遊戲帳號密碼交由他人操作，經發現該帳號以違反本規則之方式進行遊戲時，該行為等同於帳號所有者本身行為。",
                eleventh: {
                    title: "11. 本公司不進行損失補償之情形：",
                    one: "1. 玩家若因自身網路服務業者之網路斷線、自動離線或因電腦程式錯誤發生斷線情形。",
                    two: "2. 因戰爭、天災等不可抗力之因素，迫使玩家於遊戲中被迫離線。",
                    three: "3. 私下交易為違反本規則之行為，且容易造成糾紛，請玩家小心避免遭騙。若以非官方管道取得之點數、點數卡、虛寶道具發生任何問題，需由玩家自行承擔，本公司對此將不負責處理。"
                }
            },
            five: {
                title: "伍、申訴與檢舉",
                first: "1. 為消除玩家於遊戲中發現不公現象，遊戲管理員每日針對前一日遊戲成績與相關遊戲資產之數額進行安全檢查。凡遊戲歷程有作弊嫌疑或相關遊戲點數數量不正常增加之會員，都將列入查核名單。",
                second: "2. 若玩家對於本公司依本規則之處置不服時，可於收到通知之翌日起七日內致電本公司客服中心或以電子郵件或書面提出申訴。本公司接獲通知後，將審核申訴人提供之申訴資料，經審核通過後立即進行調查，並於經審核通過後十五日內回覆處理之結果。",
                third: "4. 玩家有發現他人疑似違反本規則之規範時，可向本公司進行回報或檢舉告發，本公司接獲通知後，將立即查明。經查證屬實，本公司將依本規則進行相關懲處：",
                fourth: {
                    title: "進行回報與檢舉，請附上：",
                    one: "您的暱稱(若為檢舉，請同時附上您所要檢舉的會員暱稱)",
                    two: "事由",
                    three: "事發時間、地址(遊戲區或單元或活動)",
                    four: "拍下完整圖示或其他可為證明之資料(請注意：如為檢舉，受理期限以事發當日起算一個月內，逾期恕不受理)"
                }
            }
        },
        user: {
            title: "會員服務條款",
            total: "王牌俱樂部會員服務條款",
            detail: {
                one: "歡迎您加入隆中網絡股份有限公司(以下稱本公司)會員並使用王牌俱樂部所提供之各項遊戲服務(以下稱本遊戲服務)。為保障您的權益，請詳細閱讀本服務條款所有內容，尤其當您在線上勾選「我同意」並註冊完成；或開始使用本服務時，即表示您已經詳細閱讀、了解，並同意遵守本服務條款之約定。如果您對於本條款之內容有任何的疑慮，或是不同意時，將無法繼續使用本遊戲服務。",
                two: "提醒您，要先行審閱本契約三日以上，再按「我同意」。"
            },
            content: {
                1: {
                    title: "一、當事人及其基本資料",
                    detail: {
                        one: "(一) 消費者(請依會員註冊流程填寫)",
                        two: "(二) 企業經營者：隆中網絡股份有限公司",
                        three: "代表人：顧剛維",
                        four: "統一編號：53114404",
                        five: "電話：(02)2958-9836",
                        six: "網址：https://www.aceclub.com.tw",
                        seven: "電子郵件：ac@gonline.com.tw"
                    }
                },
                2: {
                    title: "二、法定代理人",
                    detail: {
                        one: "如您為限制行為能力人或受輔助宣告之人，應經您的法定代理人、監護人或輔助人閱讀、了解並同意本契約之所有內容，本契約始生效力；若您為無行為能力人，則應由您的法定代理人或監護人代為意思表示。",
                        two: "若有限制行為能力人未經同意或無行為能力人未由法定代理人代為付費購買點數致生法定代理人主張退費時，法定代理人得備妥證明文件並提出申請，經本公司確認後，本公司將扣除必要成本及贈送點數、商品或其他服務(例如：虛擬貨幣或寶物、進階道具等)後，退還您剩餘未使用之遊戲費用。",
                        three: "本公司於官網首頁、遊戲登入頁面或購買頁面以中文明顯標示，若您為限制行為能力人或無行為能力人，除應符合第一項規定外，並應於您的法定代理人閱讀、瞭解並同意本契約之所有內容後，方得使用本遊戲服務，本契約條款變更時亦同。"
                    }
                },
                3: {
                    title: "三、定義",
                    detail: {
                        one: "(一) 遊戲管理規則：係指由本公司訂立，供作規範各遊戲進行方式之規則，且構成雙方合約之一部分，與本契約具有相同效力者。",
                        two: "(二) 禁言：使您在一定時間內無法使用任何方式發言。",
                        three: "(三) 警告通知：若您有違規的疑慮或行為，將由本公司客服人員或遊戲管理員透過線上通訊方式通知您。",
                        four: "(四) 停權：如您的帳號為違反遊戲管理規則之行為，本公司將視情節輕重處以一至七日不等之處罰，使您暫時無法使用本遊戲服務。",
                        five: "(五) 儲值：係指您以給付本公司之金額兌換為遊戲服務之點數，您得再以點數使用本遊戲服務。",
                        six: "(六) 遊戲套件：係指具備主、副程式，且能完整執行線上遊戲全部功能之軟體。",
                        seven: "(七) 必要成本：係指您進行本遊戲服務期間時，本公司之最低遊戲營運成本，包括倉儲、貨運、上下架、代銷抽成等通路成本，及設計、製造、包裝與服務遊戲點卡產生之直接成本。",
                        eight: "(八) 外掛程式：係指除本公司提供之線上遊戲程式與您的電腦設備之作業系統程式、輔助作業系統運作之相關程式、連接網際網路所需之必要程式外，非本公司所提供用以影響本公司線上遊戲程式運作或影響封包傳輸之程式。",
                        nine: "(九) 程式漏洞(BUG)：非本公司設計本遊戲服務程式時所預見或規劃之遊戲呈現方式、操作模式或所表現之遊戲結果。",
                        ten: "(十) 遊戲歷程：係指自您登入遊戲網站使用本遊戲服務起，至登出遊戲網站止，遊戲網站電腦系統對您使用本遊戲服務過程所為之記錄。",
                        eleven: "(十一) 暱稱：係指您於本遊戲服務網站中自行設定的虛擬角色的名字。",
                        twelve: "(十二) 終止契約：終止您繼續對帳號的使用權利，或將您列為本公司的拒絕往來戶。"
                    }
                },
                4: {
                    title: "四、契約內容",
                    detail: {
                        one: "以下視為本契約之一部分，與本契約條款具有相同之效力：",
                        two: "(一) 本公司有關本遊戲服務之廣告或宣傳內容。",
                        three: "(二) 計費制遊戲之費率表及遊戲管理規則。",
                        four: "本契約條款如有疑義時，以對您有利之解釋為標準。"
                    }
                },
                5: {
                    title: "五、契約解除權規定",
                    detail: {
                        one: "您得於開始遊戲後七日內，以書面告知本公司解除本契約，您無需說明理由及負擔任何費用。",
                        two: "前項情形，您得就未使用之付費購買點數扣除本公司必要成本及贈送點數、商品或其他服務(例如：虛擬貨幣或寶物、進階道具等)後，向本公司請求退費。",
                        three: "(請注意：申請退費時應檢具購買時之發票與明細及保持產品、包裝之完整性，包含銀漆不得刮開、序號不得破損或不全等，退費所產生的相關費用，由玩家自行承擔)"
                    }
                },
                6: {
                    title: "六、本遊戲服務之收費計算方式",
                    detail: {
                        one: "本遊戲服務內(例如：遊戲商城、線上商店等)有提供您額外付費購買之點數、商品或其他服務(例如：虛擬貨幣或寶物、進階道具等)，本公司在官網首頁、遊戲登入頁面或購買頁面公告均載明付款方式及商品資訊。",
                        two: "費率調整時，本公司應於預定調整生效日三十日前於官網首頁、遊戲登入頁面或購買頁面公告；若您於註冊帳號時已登錄通訊資料者，並依您登錄之通訊資料通知您。",
                        three: "費率如有調整時，應自調整生效日起按新費率計收；若新費率高於舊費率時，您在新費率生效日前已於官網中登錄之付費購買點數或遊戲費用應依舊費率計收。"
                    }
                },
                7: {
                    title: "七、本遊戲服務應載明之資訊",
                    detail: {
                        one: "本公司應於官網首頁、遊戲登入頁面或購買頁面及遊戲套件包裝上均載明以下事項：",
                        two: "(一) 依遊戲軟體分級管理辦法規定標示遊戲分級級別及禁止或適合使用之年齡層。",
                        three: "(二) 進行本遊戲服務之最低軟硬體需求。",
                        four: "(三) 有提供安全裝置者，其免費或付費資訊。",
                        five: "(四) 有提供付費購買之機會中獎商品或活動，其活動內容、獎項及中獎等資訊，並應記載「此為機會中獎商品，消費者購買或參與活動不代表即可獲得特定商品」等提示。"
                    }
                },
                8: {
                    title: "八、帳號密碼之使用與保管",
                    detail: {
                        one: "您於本公司註冊程序中應自行設定一組帳號及密碼，經本公司核對確認後，即設定該組帳號及密碼予您使用；該組帳號僅供您本人使用，若您將該組帳號、密碼轉讓、交付、揭露、出借或與第三人共用，因此所生之糾紛，您應自行負責，本公司不負協調、處理等責任。",
                        two: "前項之密碼得依本公司提供之修改機制進行變更。本公司(含客服人員、遊戲管理員)不得主動詢問您的密碼。本公司應於契約終止後三十日內，保留您的帳號及附隨於該帳號之電磁紀錄。",
                        three: "您應對您的帳號及密碼保管負責，於使用完服務後確實將帳號做登出動作，並請不要安裝非法或來路不明的外掛程式，以免帳號被他人盜用。",
                        four: "契約非因可歸責您之事由而終止者，您於第二項期間內辦理續用後，有權繼續使用帳號及附隨於該帳號之電磁紀錄。",
                        five: "第二項期間屆滿時，您仍未辦理續用，本公司得刪除該帳號及附隨於該帳號之所有資料，但法令另有規定者不在此限。"
                    }
                },
                9: {
                    title: "九、帳號密碼遭非法使用之通知與處理",
                    detail: {
                        one: "任一方如發現帳號、密碼被非法使用時，應立即通知對方並由本公司進行查證，經本公司確認有前述情事後，得暫停該組帳號或密碼之使用權，更換帳號或密碼予您，立即限制第三人就本遊戲服務之使用權利，並將相關處理方式揭載於遊戲管理規則。",
                        two: "本公司應於暫時限制遊戲使用權利之時起，即刻以官網公告、簡訊、電子郵件、推播或其他雙方約定之方式通知前項第三人提出說明。如該第三人未於接獲通知時起七日內提出說明，本公司應直接回復遭不當移轉之電磁紀錄予您，不能回復時可採其他雙方同意之相當補償方式，並於回復後解除對第三人之限制。但如本公司有提供免費安全裝置(例如：防盜卡、電話鎖等)而您不使用或有其他可歸責於您之事由，本公司不負回復或補償責任。",
                        three: "第一項之第三人不同意本公司前項之處理時，您得依報案程序，循司法途徑處理。",
                        four: "本公司依第一項規定限制您或第三人之使用權時，在限制使用期間內，本公司將不向您或第三人收取費用。",
                        five: "您如有申告不實之情形致生本公司或第三人權利受損時，您應負一切法律責任。"
                    }
                },
                10: {
                    title: "一〇、遊戲歷程之保存期限、查詢方式及費用",
                    detail: {
                        one: "本公司將保存您的個人遊戲歷程紀錄，且保存期間為三十日，以供您查詢。",
                        two: "您得以書面、網路，或親至本公司之服務中心申請調閱您的個人遊戲歷程，且須提出與身分證明文件相符之個人資料以供查驗，每個帳號查詢費用為新台幣貳佰元，需由您負擔。",
                        three: "本公司接獲您的查詢申請，應提供第一項所列之您個人遊戲歷程，並於七日內以儲存媒介或書面、電子郵件方式提供資料。"
                    }
                },
                11: {
                    title: "一一、個人資料",
                    detail: {
                        one: "本公司將遵循個人資料保護法規定及相關法律規定，保障、處理及使用您已登錄之個人資料。除法律另有規定外，未經您的同意，本公司不會將您的個人資料任意出售、交換、出租或公開，詳見本公司【隱私權政策】。 對於您個人資料的蒐集、處理、利用之範圍、您依據個人資料保護法所擁有的權利包括閱覽、複製、補充、更正或要求停止繼續蒐集、處理、利用或請求刪除個人資料及相關申請程序，本公司會於官網的「蒐集、處理及利用個人資料告知暨同意書」中載明並取得您的同意。"
                    }
                },
                12: {
                    title: "一二、電磁紀錄",
                    detail: {
                        one: "本遊戲之所有電磁紀錄均屬本公司所有，本公司並應維持相關電磁紀錄之完整。",
                        two: "您對於前項電磁紀錄有使用支配之權利。但不包括本遊戲服務範圍外之移轉、收益行為。",
                        three: "您如發現您的遊戲電磁紀錄遭不當移轉或非法使用時，準用第九條辦理。"
                    }
                },
                13: {
                    title: "一三、連線品質",
                    detail: {
                        one: "本公司為維護本遊戲服務相關系統及軟硬體設備而預先規劃暫停本遊戲服務之全部或一部時，應於七日前於官網首頁或遊戲登入頁面公告。但因臨時性、急迫性或不可歸責於本公司之事由者，不在此限。",
                        two: "因可歸責本公司事由，致您不能連線使用本遊戲服務時，本公司將立即更正或修復。對於您於無法使用期間遭扣除遊戲點數或遊戲內商品，本公司應返還遊戲點數或商品，無法返還時則應提供其他合理之補償。"
                    }
                },
                14: {
                    title: "一四、系統安全",
                    detail: {
                        one: "本公司應依本契約之規定負有於提供本遊戲服務時，維護其自身電腦系統，符合當時科技或專業水準可合理期待之安全性。",
                        two: "電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時，本公司應於採取合理之措施後儘速予以回復。",
                        three: "本公司違反前二項規定或因遊戲程式漏洞致生您損害時，應依您受損害之情形，負損害賠償責任。但本公司能證明其無過失者，得減輕其賠償責任。",
                        four: "本公司電腦系統發生第二項所稱情況時，於完成修復並正常運作之前，本公司將不會向您收取費用。",
                        five: "如您因共用帳號、委託他人付費購買點數衍生與第三人間之糾紛，本公司得不予協助處理。",
                        six: "若本公司伺服器超載致有電磁記錄無法寫入或相類似情況發生時，本公司得重開伺服器，將遊戲回復至未超載前之狀態。",
                        seven: "當本服務因硬體設備變更、調整或使用者人數增加時，您同意本公司可以將您使用的帳號及遊戲紀錄轉移或複製至其他位置，本公司也承諾願意配合進行相關設定以因應此類調整。",
                        eight: "有下列情形之一，造成本遊戲服務停止或中斷，本公司對此不負擔任何賠償責任：",
                        nine: "(一) 因不可歸責於本公司所造成本服務停止或中斷。",
                        ten: "(二) 因不可抗力所造成本服務停止或中斷。",
                        eleven: "(三) 法律明文規定。",
                        twelve: "(四) 為增進公共利益所必要。",
                        thirteen: "(五) 為免除您之生命、身體、自由或財產上之危險。",
                        fourteen: "(六) 為防止他人權益之重大危害。",
                        fifteen: "如因可歸責於您的事由，造成本遊戲服務停止或中斷時，本遊戲服務停止或中斷期間之費用，本公司仍依通常計費標準為收取；如造成本公司之損失時，本公司得向您請求損害賠償。",
                        sixteen: "對於本服務之暫停或中斷，可能造成您使用上的不便、資料遺失或其他損失，您平時應採取適當的防護措施以保障自身權益。"
                    }
                },
                15: {
                    title: "一五、遊戲管理規則",
                    detail: {
                        one: "為規範遊戲進行之方式，本公司訂立合理公平之遊戲管理規則，您使用本遊戲服務應遵守本公司公告之遊戲管理規則。",
                        two: "遊戲管理規則之變更應依第十八條之程序為之。",
                        three: "遊戲管理規則有下列情形之一者，其規定無效：",
                        four: "(一) 牴觸本契約之規定。",
                        five: "(二) 剝奪或限制您在契約上權利。但本公司依第十六條之規定處理者，不在此限。"
                    }
                },
                16: {
                    title: "一六、違反遊戲管理規則之處理",
                    detail: {
                        one: "除本契約另有規定外，有事實足證您於本遊戲服務中違反遊戲管理規則時，本公司將於官網首頁或遊戲登入頁面公告，並依您登錄之通訊資料通知您。",
                        two: "您第一次違反遊戲管理規則時，本公司將通知您於一定期間內改善。經本公司通知改善而未改善者，本公司得依遊戲管理規則，按其情節輕重限制您的遊戲使用權利。如您因同一事由再次違反遊戲管理規則時，本公司得立即依遊戲管理規則限制您進行遊戲之權利。",
                        three: "本公司依前項遊戲管理規則限制您進行遊戲之權利時，每次不得超過七日。",
                        four: "前項停止期間費用，本公司仍依通常計費標準為收取。"
                    }
                },
                17: {
                    title: "一七、申訴權利",
                    detail: {
                        one: "若您不滿意本公司提供之連線品質、遊戲管理、費用計費、其他相關之服務品質，或對本公司依遊戲管理規則之處置不服時，得於收到通知之翌日起七日內致電本公司之服務中心或以電子郵件或書面提出申訴，本公司應於接獲申訴後，於十五日內回覆處理之結果。",
                        two: "本公司二十四小時申訴管道：",
                        three: "服務中心專線：(02)2958-9836；",
                        four: "客服信箱：ac@gonline.com.tw；",
                        five: "您反映第三人利用外掛程式或其他影響遊戲公平性之申訴，依第一項規定辦理。"
                    }
                },
                18: {
                    title: "一八、契約之變更",
                    detail: {
                        one: "本公司修改本契約時，應於官網首頁或遊戲登入頁面公告之，並依您登錄之通訊資料通知您。",
                        two: "本公司未依前項進行公告及通知者，其契約之變更無效。",
                        three: "您於第一項通知到達後十五日內：",
                        four: "(一) 未為反對之表示者，本公司依契約變更後之內容繼續提供本遊戲服務。",
                        five: "(二) 以書面或電子郵件為反對之表示者，依第十九條契約終止方式處理。",
                    }
                },
                19: {
                    title: "一九、契約之終止及退費",
                    detail: {
                        one: "您得隨時以書面或電子郵件方式通知本公司終止本契約。",
                        two: "若您逾一年未登入使用本遊戲服務，本公司將通知您登入使用本遊戲服務。您於通知到達後十五日內仍未登入使用，則本公司得終止本契約。",
                        three: "您有下列重大情事之一者，本公司依您登錄之通訊資料通知您後，得立即終止本契約，如因此造成本公司之損害，本公司得向您請求損害賠償：",
                        four: "(一) 利用任何系統或工具對本公司電腦系統之惡意攻擊或破壞。",
                        five: "(二) 以利用外掛程式、病毒程式、遊戲程式漏洞或其他違反遊戲常態設定或公平合理之方式進行遊戲。",
                        six: "(三) 以冒名、詐騙或其他虛偽不正等方式付費購買點數或遊戲內商品。",
                        seven: "(四) 因同一事由違反遊戲管理規則達三次以上，經依第十六條第二項通知改善而未改善者。",
                        eight: "(五) 經司法機關查獲從事任何不法之行為。",
                        nine: "本公司對前項事實認定產生錯誤或無法舉證時，本公司應對您的損害負賠償責任。",
                        ten: "契約終止時，本公司將先扣除必要成本比例40%，再扣除贈送點數、商品或其他服務(例如：虛擬貨幣或寶物、進階道具等)後，應於三十日內以現金、信用卡、匯票或掛號寄發支票方式退還您未使用之付費購買之點數或遊戲費用，或依雙方同意之方式處理前述點數或費用。退費所產生的郵資、手續費及其相關費用，由玩家自行承擔。"
                    }
                },
                20: {
                    title: "二〇、停止營運",
                    detail: {
                        one: "因本公司停止本遊戲服務之營運而終止契約者，應於終止前三十日公告於官網首頁、遊戲登入頁面或購買頁面；若您於註冊帳號時已登錄通訊資料者，並依您登錄之通訊資料通知您。",
                        two: "本公司未依前項期間公告並通知者，除應退還您未使用之付費購買點數或遊戲費用且不得扣除必要成本外，並應提供您其他合理之補償。"
                    }
                },
                21: {
                    title: "二一、資料備份",
                    detail: {
                        one: "您同意對於所傳送之電子郵件、檔案及其他資料做備份。關於因傳送過程而造成電子郵件、檔案及其他相關電磁記錄資料之遺失，本公司不負任何擔保責任。"
                    }
                },
                22: {
                    title: "二二、智慧財產權",
                    detail: {
                        one: "本公司上之所有著作及資料，其著作權、專利權、商標、營業秘密等智慧財產權、所有權或其他權利，均為本公司或其權利人所有，除事先經本公司或其權利人之合法授權外，任何人不得擅自重製、傳輸、改作、編輯或以其他任何形式、或基於任何目的使用，違者應負相關之法律責任。"
                    }
                },
                23: {
                    title: "二三、網頁連結",
                    detail: {
                        one: "本公司在網站或所有服務相關網頁上所提供之所有連結，可能連結到其他個人、公司或組織之網站，提供該等連結之目的，僅係為便利您自行搜集或取得資訊，本公司對於被連結之該等個人、公司或組織之網站上所提供之產品、服務或資訊內容，既不擔保其真實性、完整性、即時性或可信度，該等個人、公司或組織亦不因此而當然與本公司有任何雇傭、委任、代理、合夥、合作或其他類似之關係。"
                    }
                },
                24: {
                    title: "二四、準據法及管轄法院",
                    detail: {
                        one: "本契約之解釋及適用，以及您因使用本服務所生之權利義務關係，悉依中華民國法律及相關法令解釋、適用之。因此所生之爭議，雙方同意以臺灣新北地方法院為第一審管轄法院。",
                        two: "前項約定不得排除消費者保護法第四十七條及民事訴訟法第二十八條第二項、第四百三十六條之九規定之適用。"
                    }
                }
            }
        },
        privacy: {
            title: "隱私權條款",
            total: "隱私權政策",
            detail: "本《隱私權政策》適用於所有由隆中網絡股份有限公司(以下稱本公司)提供的產品、服務和網站。為了讓您能夠安心的使用本公司各項服務與資訊，特此向您說明本公司隱私權保護政策，以保障您的權益，請您詳閱下列內容：",
            content: {
                one: "一、名詞解釋：",
                two: "(一)Cookie 和類似技術：",
                three: "Cookie 是內含一串字元的小檔案，由網站在您造訪時傳送到您的電腦。當您再次瀏覽同一個網站時，該網站就能透過 Cookie 辨識您的瀏覽器。Cookie 可能會儲存使用者偏好設定和其他資訊。您可以重設瀏覽器，讓瀏覽器拒絕所有 Cookie，或是在 Cookie 傳送時顯示提醒。不過，某些網站功能或服務必須用到 Cookie 才能正常運作。因此，在其他無法使用或不適用 Cookie 的平台上，系統會使用別的技術 (例如 Android 行動裝置中的廣告 ID) 替代 Cookie。",
                four: "(二)IP 位址：",
                five: "每個連上網際網路的裝置都會自動獲派一組數字，稱為網際網路通訊協定 (IP) 位址。IP 位址一般是依地理區塊指派，通常可用於識別裝置是從哪個地點連上網際網路。",
                six: "(三)伺服器記錄：",
                seven: "本公司的伺服器就像大多數網站一樣，會自動記錄您瀏覽網站時送出的網頁要求。這些「伺服器記錄」通常包含網頁要求、網際網路通訊協定位址、瀏覽器類型、瀏覽器語言、要求的日期和時間，以及一或多個能夠正確識別您瀏覽器的 Cookie。",
                eight: "(四)個人資料：",
                nine: "這是指您提供給本公司的個人身分識別資訊，例如您的姓名、出生年月日、聯絡方式，及其他得以直接或間接方式識別該個人之資料。",
                ten: "(五)蒐集：",
                eleven: "指以任何方式取得個人資料。",
                twelve: "(六)處理：",
                thirteen: "指為建立或利用個人資料檔案所為資料之記錄、輸入、儲存、編輯、更正、複製、檢索、刪除、輸出、連結或內部傳送。",
                fourteen: "(七)利用：",
                fifteen: "指將蒐集之個人資料為處理以外之使用。",
                sixteen: "二、個人資料的蒐集、處理及利用方式",
                seventeen: "(一)申請加入本公司網站會員時，需請您提供個人的手機資料或以Facebook帳號認證，以便在您登入本公司網站之服務後，就能辨別您的身分，並提供更友善的個人化服務；您可以自行設定一組專屬於您的會員帳號及密碼或以Facebook帳號，作為您登入本公司網站及您使用本公司網站所提供之產品、服務時的唯一身分識別，請您自行妥善保管該會員帳號及密碼。",
                eighteen: "(二)為了讓本公司為您提供更完善的服務，您也可以自由在本公司網站會員資料中登錄各類個人識別資料，以便於本公司網站購物、參與本公司及合作廠商所舉辦之各類活動或協助進行數據統計及分析。但如因此產生金流或物流之必要，本公司可能要求您提供可證明前述個人識別資料等文件正本、傳真或影本，並可能將您前述個人識別資料中因服務所必要之部分提供給相關機關或合作、協力廠商作為交易驗證或提供服務之用。",
                nineteen: "(三)本網站在您使用服務信箱、問卷調查等互動性功能或參與本網站活動時，本公司將視業務或活動性質請您提供必要的個人資料，並會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等，在該特定目的範圍內處理及利用您的個人資料。非經您書面同意，本網站不會將個人資料用於其他用途。",
                twenty: "(四)於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為本公司增進網站服務的參考依據，此記錄為內部應用，決不對外公布。",
                twentyOne: "(五)為提供精確的服務，本公司會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，本公司會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。",
                twentyTwo: "(六)為整體評估各個網頁的流量、使用者進入本公司網站之路徑等資料，本公司會保留30日您在上網瀏覽時伺服器自行產生的相關記錄，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，以利於提昇本公司網站的服務品質。本公司網站僅對全體使用者行為總和進行分析，並不會對個別使用者進行分析。",
                twentyThree: "(七)本公司可能使用「Cookies檔案」收集用戶對服務的使用資料，這樣有助於用戶再度到訪網站時之用。「Cookies檔案」是由網絡伺服器發出的一小段資料，儲存於網絡瀏覽器之中，使日後可從該瀏覽器閱讀該段資料。目前，從Cookies檔案收集到的資料用於提高服務的功能。本公司服務所提供的資料，是根據本公司就用戶對服務的累積使用進行分析，然後加以組織和編排的。Cookies檔案有助同時能使登入程序更順暢更快捷，以及保存通話期之間的資料。您可以關閉您瀏覽器上的Cookies檔案功能而不影響到您瀏覽本公司網站，但Cookies檔案確實可使本公司服務更方便。關閉Cookies檔案功能可能會造成使用的複雜程度和涉及較多的輸入手續。您亦應留意，若您清除Cookies檔案功能，則可能影響到本公司服務的某些功能。",
                twentyFour: "三、本公司將採行適當之安全措施，並盡力以合理之技術及措施，依相關法令辦理安全維護事項，防止您的個人資料被竊取、竄改、毀損、滅失或洩漏。且非經您本人同意不會自行修改或刪除任何會員之個人資料及檔案。除非是為了向您提供您所要求的產品或服務、獲得您的授權，或有以下情形，否則本公司不會向任何其他人出借或出售您的個人資料，或與之分享：",
                twentyFive: "(一)經由合法的途徑。",
                twentySix: "(二)為保護本公司網站各相關單位之權益。",
                twentySeven: "(三)配合司法單位合法的調查。",
                twentyEight: "(四)配合相關職權機關依職務需要之調查或使用。",
                twentyNine: "(五)基於善意相信揭露為法律需要，或為維護和改進網站服務而用於管理。",
                thirty: "(六)若您對本公司要求提供任何服務，本公司網站將會根據您的個人資料發送有關之行銷資訊。",
                thirtyOne: "(七)根據契約與本公司合作商業營運之服務供應商，例如為了防止詐欺行為，為了行銷目的所為之收集資料，或提供技術服務。而這些服務供應商僅能於其服務範圍內使用您的個人資料，將不會用於其他任何商業用途。",
                thirtyTwo: "(八)本公司計劃合併或收購之公司。若有前開情事，本公司將會要求新合併的實體遵循公司隱私權政策，並尊重您的個人資料保密性。",
                thirtyThree: "四、與第三人共用個人資料之政策",
                thirtyFour: "(一)本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。",
                thirtyFive: "(二)前項但書之情形包括不限於：",
                thirtySix: "1. 經由您書面同意。",
                thirtySeven: "2. 法律明文規定。",
                thirtyEight: "3. 為維護國家安全或增進公共利益。",
                thirtyNine: "4. 為免除您生命、身體、自由或財產上之危險。",
                forty: "5. 公務機關或學術研究機構基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。",
                fortyOne: "6. 當您在網站的行為，違反服務條款或可能損害或妨礙或導致任何人遭受損害時，揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。",
                fortyTwo: "7. 有利於您的權益。",
                fortyThree: "(三)本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。",
                fortyFour: "(四) 本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料。",
                fortyFive: "五、隱私權政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。您也可經由本網站所提供的連結，點選進入本網站的網頁提供其他對外網站的網路連結，但該連結網站不適用本網站的隱私權政策，您必須參考該連結網站中的隱私權保護政策。隱私權政策也不適用於非本網站所委託或參與管理的人員。",
                fortySix: "六、隱私權保護政策之修正本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。",
                fortySeven: "七、特別注意事項",
                fortyEight: "(一)若相關法律之規定與本隱私權政策有所衝突，本公司將遵循該法律之規定。",
                fortyNine: "(二)您如果對於個人資料有關之相關事項有任何意見或疑問，可以和本公司客服中心聯絡，電話：(886)02-2958-9836。",
                fifty: '八、王牌俱樂部有使用 Facebook登入應用。',
                fiftyOne: '雖然我們不會在我們的伺服器裡保存您的個人資料，但是根據Facebook的政策，我們必須提供 “Facebook資料刪除指示的網址” (這個網頁)。',
                fiftyTwo: '如果您想刪除與王牌俱樂部有關的Facebook登入應用數據，您可以按照以下步驟進行：',
                fiftyThree: '1. 進入您的Facebook帳號的 “設定和隱私 “選單。點擊 “設定”',
                fiftyFour: '2. 向下滾動並點擊 “應用程式和網站”',
                fiftyFive: '3. 找到並點擊 “王牌俱樂部”',
                fiftySix: '4. 點擊 “移除 “按鈕',
                fiftySeven: '恭喜您，您已經成功地刪除了您的王牌俱樂部應用程式活動。'
            }
        },
        personal: {
            title: "個人資料使用同意書",
            total: "蒐集、處理及利用個人資料告知暨同意書",
            content: {
                1: {
                    title: "壹、一般會員告知暨同意書：",
                    one: "隆中網絡股份有限公司(以下稱本集團)、與本集團具有母子公司、控制或從屬關係之企業、以及由本集團實際負責 人設立或營運之單位（以下合稱「本集團」），將依隱 私權政策向您蒐集及利用您的個人資料，並依據個人 資料保護法(下稱個資法)第 8 條第 1 項規定，向您告 知下列事項，請您詳閱並同意本集團為您個人資料之 利用：",
                    two: "一、名詞解釋：",
                    three: "(一)個人資料：指姓名、出生年月日、國民身分證統一編號、聯絡方式、社會活動及其他得以直接或間接方式識別該個人之資料。",
                    four: "(二)蒐集：指以任何方式取得個人資料。",
                    five: "(三)處理：指為建立或利用個人資料檔案所為資料之記錄、輸入、儲存、編輯、更正、複製、檢索、刪除、輸出、連結或內部傳送。",
                    six: "(四)利用：指將蒐集之個人資料為處理以外之使用。",
                    seven: "(五)國際傳輸：指將個人資料作跨國（境）之處理或利用。",
                    eight: "二、蒐集之目的（依據法務部公告之「個人資料保護法之特定目的及個人資料之類別」填載如下，代號及項目名稱嗣後如經法務部公告變更，亦隨同變更之）：(一）○三六 存款與匯款；(二）○四○ 行銷（包含金控共同行銷業務）；(三）○六九 契約、類似契約或其他法律關係事務；(四）○九○ 消費者、客戶管理與服務；(五）○九八 商業與技術資訊；(六）一二○ 稅務行政；(七）一三五 資（通）訊服務；(八）一三六 資（通）訊與資料庫管理；(九）一三七 資通安全與管理；(十）一四八 網路購物及其他電子商務服務；(十一）一五七 調查、統計與研究分析；(十二）一六八 護照、簽證及文件證明處理；(十三）一八一 其他經營合於營業登記項目或組織章程所定之業務；(十四）一八二 其他諮詢與顧問服務。",
                    nine: "三、蒐集之個人資料類別（依據法務部公告之「個人資料保護法之特定目的及個人資料之類別」填載如下，代號及項目名稱嗣後如經法務部公告變更，亦隨同變更之）：(一）Ｃ○○一 辨識個人者；(二）Ｃ○○二 辨識財務者；(三）Ｃ○○三 政府資料中之辨識者；(四）Ｃ○一一 個人描述；(五）Ｃ○三一 住家及設施；(六）Ｃ○三三 移民情形； (七）Ｃ三五 休閒活動及興趣； (八）Ｃ○三八 職業； (九）Ｃ○八三 信用評等； (十）Ｃ一三二 未分類之資料。",
                    ten: "四、個人資料利用之期間、地區、對象及方式：",
                    eleven: "(一)期間：",
                    twelve: "除法令另有規定外，本集團使用您個人資料期間自您成為本集團網站內與其所附屬網站的會員日起，至您提出申請終止會員服務或因違反會員服務條款被終止服務日為止。",
                    thirteen: "(二)地區：",
                    fourteen: "本集團所在地，及本集團所有有關的網站與其所附屬網站。",
                    fifteen: "(三)對象：",
                    sixteen: "本集團。但基於履行契約目的情形下，將用作本集團進行會員驗證、數據統計及分析、獎項兌換、廣告行銷、會員服務訊息、特別活動、新服務、新產品之通知等用途，以履行與您的契約義務。",
                    seventeen: "(四)方式：",
                    eighteen: "符合個人資料相關法令以自動化機器或其他非自動化之利用方式之蒐集、處理、國際傳輸與利用（例如使用電子文件、紙本或其他合於當時科學技術之適當方式等）。",
                    nineteen: "五、依據個資法第3條規定，您就本集團保有之您的個人資料得行使下列權利：",
                    twenty: "(一)得向本集團查詢、請求閱覽或請求製給複製本，而本集團依法得酌收必要成本費用。",
                    twentyOne: "(二)得向本集團請求補充或更正。惟依個人資料保護法施行細則第19條規定，您應為適當之釋明其原因及事實。",
                    twentyTwo: "(三)得向本集團請求停止蒐集、處理或利用及請求刪除。",
                    twentyThree: "(四)依個資法第11條第2項規定，個人資料正確性有爭議者，得向本集團請求停止處理或利用您個人資料。惟依該項但書規定，本集團因執行業務所必須並註明其爭議或經您書面同意者，不在此限。",
                    twentyFour: "(五)依個資法第11條第3項規定，個人資料蒐集之特定目的消失或期限屆滿時，得向本集團請求刪除、停止處理或利用您之個人資料。惟依該項但書規定，本集團因執行業務所必須或經您書面同意者，不在此限。",
                    twentyFive: "(六)本集團如有違反個資法規定蒐集、處理或利用您之個人資料，依個資法第11條第4項規定，您得向本集團請求停止蒐集。",
                    twentySix: "六、前條權利之申請，應填具申請文件。本集團得向您請求提出可資確認之身分證明文件；如果是委託他人代為申請，請出具委任書，並且提供本人及代理人的身分證明文件。如果您不符合本集團申請程序或法令另有規定時，權利之申請將會受到限制。",
                    twentySeven: "七、您得自由選擇是否提供相關個人資料，惟您若拒絕提供相關個人資料，本集團將無法進行和您的聯繫、完成交易、提供服務、身分驗證或處理消費、交易或客訴等等問題，致可能影響您權益或無法進行本集團之服務。"
                },
                2: {
                    title: "貳、歐盟地區會員告知暨同意書",
                    one: "歐盟地區會員告知暨同意書(下稱「本同意書」)根據「歐盟一般資料保護規範」(General Data Protection Regulation，簡稱GDPR)所訂定，適用於歐盟地區使用本集團產品之自然人。本同意書未有規定者，依本集團「隱私權政策」及「一般會員告知暨同意書」(下稱「一般同意書」)辦理。",
                    two: "一、本集團為了提供會員服務而徵求您同意本集團蒐集、合法的應用您的個人識別資料(蒐集之個人資料類別，詳參一般同意書第3條規定)，並保留您的個人識別資料於本集團系統(個人資料被儲存之期間為30日，詳參隱私權政策第2條第6項規定)。本集團蒐集您的個人識別資料僅為了提供會員服務(蒐集目的，詳參一般同意書第2條規定)。您可以隨時撤回您的同意，但不影響撤回前本集團已對您的個人識別資料的使用。",
                    three: "二、有關以下您的個人識別資訊權利之行使，如牴觸法規、公務機關公權力、公共利益或將造成他人的損害，則本集團得限縮您對於您個人識別資料的權利行使。",
                    four: "三、為使用本集團的服務，您的資訊可能會被轉移至歐盟境外，並依處理目的提供給與本集團合作之各電信商或廣告商。本集團將會採取符合法規的保密措施，以確保您個人識別資料儲存的保密性及完整性，並將以適當的技術及組織架構防止非法處理或遺失、破壞、損壞。經由您的申請，本集團依第12條之程序告知您合適或適當之保護措施及取得該副本或該副本可得取用之方式。",
                    five: "四、您可以隨時提供更新您的個人識別資料。考量到處理之目的，您應有權完整化其有欠缺之個人資料，包括以提供補充說明之方式，並確保過時的以及不正確的資訊將立即被更正及刪除。",
                    six: "五、在下列情況下，除法律另有規定、公共利益外，您可以要求本集團清除所持有之您的個人資料，但如因您選擇刪除個人識別資料，可能會導致本集團無法為您提供服務，或因不知您的偏好，而無法提供與其他會員相同的服務：",
                    seven: "（一）個人資料對於蒐集或處理目的不再需要者。",
                    eight: "（二）本集團處理根據您同意所持有之該個人資料，您取消同意且本集團沒有其他可以作為處理該個人識別資料之理由；",
                    nine: "（三）本集團就直接行銷目的處理個人識別資料時，您有權隨時拒絕為行銷目的所涉及其個人識別資料之處理。",
                    ten: "（四）您認為本集團正在非法處理您的個人識別資料。",
                    eleven: "（五）依法規本集團有義務刪除個人識別資料。",
                    twelve: "六、於下列情事者，除儲存外，應僅限基於您之同意、或為建立、行使或防禦法律上請求、或為保護他人或法人之權利、或基於歐盟法或會員國法律所定重要公共利益之理由外，您應有權限制本集團之處理(限制個人資料處理之方法包括但不限於將所選之資料移至另一個處理系統，例如存檔目的，或使所選之資料無法被取得)：",
                    thirteen: "（一）您質疑其個人資料之正確性，而給予本集團驗證該個人資料正確性之期間；",
                    fourteen: "（二）處理係違法的，且您拒絕刪除該個人資料並要求限制其使用者；",
                    fifteen: "（三）本集團就其處理之目的不再需要該個人資料，但該個人資料為您建立、行使或防禦法律上請求所必須者；",
                    sixteen: "（四）您已依照本集團因追求公共利益程序而拒絕該處理，在等待確認本集團是否具有優先於您權益之正當理由。",
                    seventeen: "七、您依前條規定已限制處理者，本集團將於取消處理限制前通知您。",
                    eighteen: "八、除經證明不可能為通知，或通知須花費過鉅之勞費者外，本集團就您請求的任何更正或刪除個人資料或限制處理向個人資料受揭露之與本集團合作之各電信商或廣告商為通知。",
                    nineteen: "九、除您依第5條規定請求本集團刪除個人資料之處理、利於本集團符合公共利益執行職務之處理及不影響他人之權利與自由外，您有權以結構性的、通常使用的、機器可讀的形式獲得您之前提供給本集團的個人識別資料。如果技術上許可，您可以要求本集團協助將您的個人識別資料傳輸給第三方。但本集團無法對第三方收到的個人識別資料後處理的安全性承擔任何責任。",
                    twenty: "十、除本集團證明個人資料之處理有優先於您的權利及自由之法律依據、或為建立、行使或防禦法律上請求所為之者外，您有權基於與其具體情況有關之理由，隨時拒絕本集團對於符合公共利益、追求正當利益之目的或行銷目的對您個人識別資料之處理。但如因您拒絕提供個人識別資料，可能會導致本集團無法為您提供服務，或因不知您的偏好，而無法提供與其他會員相同的服務。",
                    twentyOne: "十一、本集團提供執行適當保護措施以確保資料主體之權利及自由及正當利益。",
                    twentyTwo: "十二、本集團應向您提供您依第3條至第11條提出之請求所欲採取行動之資訊，如本集團對於您依照第3條至第10條提出請求之您身分有合理懷疑者，本集團得要求提供為確認該您身分所必要之額外資訊。本集團最遲應於收到請求後1個月內為您依第3條至第11條提出之請求所欲採取行動之資訊，考量到請求之複雜性及數量，該期限於必要時得再延長2個月；本集團於收到請求後1個月內通知資料主體該展期，並說明遲延之原因。如本集團不同意您之要求者，該本集團應立即且最遲於收到您要求之1個月內以書面方式(包含電子郵件)附具理由告知您，並與您敘明得向監管機關提起申訴之權利及該監管機關之聯繫方式與尋求司法救濟之可能性。",
                    twentyThree: "十三、於個人資料侵害發生時，本集團應於發現後72 小時內向監管機關通報，但個人資料侵害無造成對當事人權利及自由之風險時，不在此限。有未於72小時內向監管機關通報之情形，通報應附遲延之理由。通報至少應分階段提供下列資訊，不得有進一步之無故遲延：",
                    twentyFour: "（一）描述個人資料侵害之本質，如有可能，應包括相關資料主體之類型及大致數量，及相關個人資料紀錄之類型及大致數量；",
                    twentyFive: "（二）描述個人資料侵害之可能結果；",
                    twentySix: "（三）描述本集團已採取或預計採取用以處理個人資料侵害之措施，如適當，應包括降低可能不利影響之措施。",
                    twentySeven: "十四、本集團於個人資料之處理時，在客觀評鑑基礎上，參考資料處理之本質、範圍、過程與目的時，發覺有導致您的權利及自由即受侵害之虞，除符合下列條件之一者外，將盡快以清楚簡易之語言描述個人資料侵害之可能結果、採取或預計採取用以處理個人資料侵害之措施與您溝通個人資料之侵害；且與監管機關密切合作，並尊重其或其他相關機關提供之指示：",
                    twentyEight: "（一）本集團已執行適當之科技化與有組織之措施，且該等措施已適用於受個人資料侵害影響之個人資料，尤其已使未獲授權接近使用之人無法識別個人資料(如加密)；",
                    twentyNine: "（二）本集團已採取後續措施，確保對您權利及自由侵害之高風險已不會實現；",
                    thirty: "（三）涉及不符比例之努力。惟本集團有公共溝通或類似措施使您獲相同有效之通知。",
                    thirtyOne: "（四）於避免妨礙官方或法律詢問、調查、或程序，避免妨礙預防、調查、偵查及追訴刑事犯罪或執行刑罰，保護公共利益、保護國家安全或保護他人之權利及自由無法由延遲或限制對相關當事人之溝通而達成。",
                    thirtyTwo: "十五、 於您請求本集團於蒐集您個人資料時應提供之資訊、請求第3條至第11條之權利行使及第14條任何溝通及採取之任何行動之通知時，本集團應無償提供之副本一份。如您之請求明顯無理由或過度者，尤其是基於該等請求過於重複者，本集團得考量所要求提供之資訊或溝通或採取行動之行政成本，收取適當費用；或拒絕該請求。"
                },
                3: {
                    title: "參、為保障您的權益，請定期瀏覽本集團網站關於本同意書的公告。當您於本同意書為修改或變更後，繼續使用本集團網站與其所附屬之網站服務，表示您已閱讀、瞭解並同意接受本同意書修改或變更後之內容。如果您不同意本同意書，請您立即停止使用本集團網站與其所附屬之網站服務。"
                },
                4: {
                    title: "肆、您如果對於本集團就您的個人資料之蒐集、處理及利用有任何意見或疑問，可以和本集團客服中心聯絡，電話：(886)02-2958-9836。"
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/i18n/tw.js